import VueRouter from "vue-router";

const router = new VueRouter({
    mode: "history",
    routes: [
        {
            path: "*",
            component: () => import("~/components/views/404.vue"),
        },
        {
            path: "/",
            name: "root",
            component: () => import("#/App.vue"),
            redirect: { name: "home" },
            children: [
                {
                    path: "/signup",
                    name: "signup",
                    component: () => import("#/Pages/Signup.vue"),
                },
                {
                    path: "/ovflanding",
                    name: "ovflanding",
                    component: () => import("#/Pages/OverflowLandingPage.vue"),
                },
                {
                    path: "dashboard",
                    name: "home",
                    component: () => import("#/Pages/Dashboard.vue"),
                },
                {
                    path: "verify-id",
                    name: "verify-id",
                    component: () => import("#/Pages/VerifyId.vue"),
                },
                {
                    path: "credit-reports-summary",
                    name: "credit-reports.summary",
                    component: () => import("#/Pages/CreditReportsSummary.vue"),
                },
                {
                    path: "credit-reports",
                    component: () => import("#/Pages/CreditReport.vue"),
                    children: [
                        {
                            path: "",
                            name: "credit-reports.overview",
                            component: () =>
                                import("#/Pages/CreditReports/Overview.vue"),
                        },
                        {
                            path: "accounts",
                            name: "credit-reports.accounts",
                            component: () =>
                                import("#/Pages/CreditReports/Accounts.vue"),
                        },
                        {
                            path: "enquiries",
                            name: "credit-reports.enquiries",
                            component: () =>
                                import("#/Pages/CreditReports/Enquiries.vue"),
                        },
                        {
                            path: "defaults",
                            name: "credit-reports.defaults",
                            component: () =>
                                import("#/Pages/CreditReports/Defaults.vue"),
                        },
                        {
                            path: "judgements",
                            name: "credit-reports.judgements",
                            component: () =>
                                import("#/Pages/CreditReports/Judgements.vue"),
                        },
                        {
                            path: "insolvencies",
                            name: "credit-reports.insolvencies",
                            component: () =>
                                import("#/Pages/CreditReports/Insolvencies.vue"),
                        },
                        {
                            path: "public-records",
                            name: "credit-reports.public-records",
                            component: () =>
                                import("#/Pages/CreditReports/PublicRecords.vue"),
                        },
                        {
                            path: "infringements",
                            name: "credit-reports.infringements",
                            component: () =>
                                import("#/Pages/CreditReports/Infringements.vue"),
                        },
                        {
                            path: "personal-information",
                            name: "credit-reports.personal-information",
                            component: () =>
                                import("#/Pages/CreditReports/PersonalInformation.vue"),
                        },
                    ],
                },
                {
                    path: "faq",
                    name: "faq",
                    component: () => import("#/Pages/FAQ.vue"),
                },
                {
                    path: "spending-habits",
                    component: () => import("#/Pages/SpendingHabits.vue"),
                    children: [
                        {
                            path: "",
                            name: "spending-habits.overview",
                            component: () =>
                                import("#/Pages/SpendingHabits/Index.vue"),
                        },
                        {
                            path: "income-details",
                            name: "spending-habits.income-details",
                            component: () =>
                                import("#/Pages/SpendingHabits/IncomeDetails.vue"),
                        },
                        {
                            path: "spending-details",
                            name: "spending-habits.spending-details",
                            component: () =>
                                import("#/Pages/SpendingHabits/SpendingDetails.vue"),
                        },
                        {
                            path: "debt",
                            name: "spending-habits.debt",
                            component: () =>
                                import("#/Pages/SpendingHabits/Debt.vue"),
                        },
                        {
                            path: "connect",
                            name: "spending-habits.connect",
                            component: () =>
                                import("#/Pages/SpendingHabits/ConnectAccount.vue"),
                        },
                    ],
                },
                {
                    path: "upgrade-now",
                    name: "upgrade-now",
                    component: () => import("#/Pages/UpgradeNow.vue"),
                },
                {
                    path: "set-first-password",
                    name: "set-first-password",
                    component: () => import("#/Pages/SetFirstPassword.vue"),
                },
                {
                    path: "offers",
                    component: () => import("#/Pages/Offers.vue"),
                    children: [
                        {
                            path: "",
                            name: "products",
                            component: () => import("#/Pages/Offers/Index.vue"),
                        },
                        {
                            path: "good-credit-loans/apply",
                            name: "products.good-credit-loans.apply",
                            component: () =>
                                import("#/Pages/Offers/GoodCreditLoansApply.vue"),
                        },
                        {
                            path: "small-loans/offers",
                            name: "products.small-loans.offers",
                            component: () =>
                                import("#/Pages/Offers/SmallLoansOffersList.vue"),
                        },
                        {
                            path: "small-loans/apply",
                            name: "products.small-loans.apply",
                            component: () =>
                                import("#/Pages/Offers/SmallLoansApply.vue"),
                        },
                        {
                            path: "small-loans/results/:uuid",
                            name: "products.small-loans.results",
                            component: () =>
                                import("#/Pages/Offers/SmallLoansOffersResults.vue"),
                        },
                        {
                            path: "car-loans/apply",
                            name: "products.car-loans.apply",
                            component: () =>
                                import("#/Pages/Offers/CarLoansApplyLoanOptionsForm.vue"),
                        },
                        {
                            path: "car-loans/results/:uuid",
                            name: "products.car-loans.results",
                            component: () =>
                                import("#/Pages/Offers/CarLoansOffersResults.vue"),
                        },
                    ],
                },
                {
                    path: "credit-school",
                    component: () => import("#/Pages/CreditSchool.vue"),
                    children: [
                        {
                            path: "",
                            name: "credit-school",
                            component: () =>
                                import("#/Pages/CreditSchool/Index.vue"),
                        },

                        {
                            path: "lessons/:id",
                            name: "credit-school.lessons.show",
                            component: () =>
                                import("#/Pages/CreditSchool/ShowLesson.vue"),
                        },
                        {
                            path: "lessons/:lesson_id/topics/:topic_id",
                            name: "credit-school.lessons.topic.show",
                            component: () =>
                                import("#/Pages/CreditSchool/ShowTopic.vue"),
                        },
                        {
                            path: "lessons/:lesson_id/topics/:topic_id/quizzes/:quiz_id?",
                            name: "credit-school.lessons.topic.quizzes.show",
                            component: () =>
                                import("#/Pages/CreditSchool/ShowQuiz.vue"),
                        },
                    ],
                },
                {
                    path: "settings",
                    component: () => import("#/Pages/Settings.vue"),
                    children: [
                        {
                            path: "",
                            name: "settings.index",
                            component: () =>
                                import("#/Pages/Settings/Index.vue"),
                        },
                        {
                            path: "reset-password",
                            name: "settings.reset-password",
                            component: () =>
                                import("#/Pages/Settings/ResetPassword.vue"),
                        },
                        {
                            path: "close-account",
                            name: "settings.close-account",
                            component: () =>
                                import("#/Pages/Settings/CloseAccount.vue"),
                        },
                        {
                            path: "update-details",
                            name: "settings.update-details",
                            component: () =>
                                import("#/Pages/Settings/UpdateDetails.vue"),
                        },
                        {
                            path: "subscription",
                            name: "settings.subscription",
                            component: () =>
                                import("#/Pages/Settings/Subscription.vue"),
                        },
                    ],
                },
                {
                    path: "creditrepair",
                    redirect(to) {
                        // Redirect to external url
                        // URL - https://credit-repair.tippla.com.au/saml2/prod/login
                        let url =
                            import.meta.env.VITE_CREDIT_REPAIR_DESTINATION ??
                            "https://credit-repair.tippla.com.au/saml2/prod/login";

                        window.location.href = url;
                    },
                },
                {
                    path: "giveaways",
                    component: () => import("#/Pages/Raffle.vue"),
                    children: [
                        {
                            path: "",
                            name: "giveaways.index",
                            component: () => import("#/Pages/Raffle/Index.vue"),
                        },
                        {
                            path: "page/:id",
                            name: "giveaways.page",
                            component: () => import("#/Pages/Raffle/Page.vue"),
                        },
                        {
                            path: "winners",
                            name: "giveaways.winners",
                            component: () =>
                                import("#/Pages/Raffle/Winners.vue"),
                        },
                    ],
                },
            ],
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    },
});

router.onError((error, to) => {
    if (
        error.message.includes("Failed to fetch dynamically imported module") ||
        error.message.includes("Importing a module script failed")
    ) {
        if (typeof to === "object" && to.hasOwnProperty("fullPath")) {
            window.location = to.fullPath;
        } else {
            window.location.reload();
        }
    }
});

export default router;
